const palette = {
  primary: {
    main: "#004337 ",
    contastText: "#ffffff",
  },
  secondary: {
    main: "#F8F9F1",
    contastText: "#004337",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
